import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import Formatter from '../../Utilities/Formatter';
import DataLayer from '../../Utilities/DataLayer';

export default class PotentialTeamLeaderCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideButton: (this.props.hideButton == null) ? false : this.props.hideButton
        }
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.dataLayer = new DataLayer();
        this.formatter = new Formatter();
    }

    componentWillReceiveProps() {
        this.props.loaderOff();
    }

    render() {
        return (
            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                <MDBCardText>
                    <MDBIcon icon="user" />&nbsp;{this.props.manager.sfName}<br />
                    <MDBIcon far icon="id-card" />&nbsp;{this.props.manager.unitCode}<br />
                    <MDBIcon icon="sitemap" />&nbsp;{this.props.manager.status}
                </MDBCardText>
                <hr />
                <MDBCardText>
                    <div className="text-center">
                        <strong><u>{this.props.manager.period}</u></strong>
                    </div>
                    <MDBRow>
                        <MDBCol className="text-center">
                            <p>
                                <span>Unit Sales</span><br />
                                <span><strong>{this.formatter.formatCurrency(this.props.manager.periodSales)}</strong></span>
                            </p>
                            <p>
                                <span>New P/O's</span><br />
                                <span><strong>{this.props.manager.newUnit}</strong></span>
                            </p>
                        </MDBCol>
                        <MDBCol className="text-center">
                            <p>
                                <span>New Recruits</span><br />
                                <span><strong>{this.props.manager.newRec}</strong></span>
                            </p>
                            <p>
                                <span>Qual Recruits</span><br />
                                <span><strong>{this.props.manager.qualRec}</strong></span>
                            </p>
                        </MDBCol>
                    </MDBRow>
                </MDBCardText>
                <hr />
                <MDBCardText>
                    <div className="text-center">
                        <strong><u>{this.props.manager.period2}</u></strong>
                    </div>
                    <MDBRow>
                        <MDBCol className="text-center">
                            <p>
                                <span>Unit Sales</span><br />
                                <span><strong>{this.formatter.formatCurrency(this.props.manager.periodSales2)}</strong></span>
                            </p>
                            <p>
                                <span>New P/O's</span><br />
                                <span><strong>{this.props.manager.newUnit2}</strong></span>
                            </p>
                        </MDBCol>
                        <MDBCol className="text-center">
                            <p>
                                <span>New Recruits</span><br />
                                <span><strong>{this.props.manager.newRec2}</strong></span>
                            </p>
                            <p>
                                <span>Qual Recruits</span><br />
                                <span><strong>{this.props.manager.qualRec2}</strong></span>
                            </p>
                        </MDBCol>
                    </MDBRow>
                </MDBCardText>
                <hr />
                <MDBCardText>
                    <div className="text-center">
                        <strong><u>{this.props.manager.period3}</u></strong>
                    </div>
                    <MDBRow>
                        <MDBCol className="text-center">
                            <p>
                                <span>Unit Sales</span><br />
                                <span><strong>{this.formatter.formatCurrency(this.props.manager.periodSales3)}</strong></span>
                            </p>
                            <p>
                                <span>New P/O's</span><br />
                                <span><strong>{this.props.manager.newUnit3}</strong></span>
                            </p>
                        </MDBCol>
                        <MDBCol className="text-center">
                            <p>
                                <span>New Recruits</span><br />
                                <span><strong>{this.props.manager.newRec3}</strong></span>
                            </p>
                            <p>
                                <span>Qual Recruits</span><br />
                                <span><strong>{this.props.manager.qualRec3}</strong></span>
                            </p>
                        </MDBCol>
                    </MDBRow>
                </MDBCardText>
                <hr />
                {
                    (!this.state.hideButton) ?
                        (
                            <div className="flex-row text-center" >
                                <MDBBtn tag="a" color="purple" floating onClick={() => this.props.loadPromoteOuts(this.props.manager.type)}>
                                    <MDBIcon icon="level-up-alt" />
                                </MDBBtn>
                            </div>
                        ) : (<div></div>)
                }

            </MDBCard >
        )
    }
}